import PredictionsModel from "../Predictions/PredictionsModel";

export default class MatchSummaryModel {
    public matchId: string = null;
    public matchType: string = null;
    public predictions: PredictionsModel = null;
}